<div class="container-fluid dialog-container" [dir]="htmlDirection">
  <div class="d-flex justify-content-start mt-3">
    <section-title translate>{{ data.title }}</section-title>
  </div>
  <div class="pt-3">
    <img class="dialog-img w-100" [src]="data.imageUrl | assets" />
    <h6 class="my-3 text-center" [innerHTML]="data.html"></h6>
  </div>
  <div class="ahoy-secondary-divider mb-0"></div>
  <div class="d-flex justify-content-end p-3 gap-2">
    @if (data.showCancelButton) {
      <button mat-stroked-button color="primary" (click)="close()">
        <span translate>{{ data.cancelButtonText || 'Close' }}</span>
      </button>
    }
    <button mat-flat-button color="primary" (click)="confirm()">
      <span translate>{{ data.confirmButtonText || 'Confirm' }}</span>
    </button>
  </div>
</div>
